import React, { Component } from "react";
import { adminService, dateHelper, networkErrorHelper } from "libs";
import { Button, Card, CardBody, Container } from "design-react-kit";
import { BoxDanger, Title } from "components/misc";
import { MTable } from "components/table";

import { MnemoLoading } from "components/misc";
import { withRouter } from "react-router-dom";
import { MSelect } from "components/forms";
import { ACCOUNT_WEBEX } from "const";
import AdminLessonTrainingRegistrationIDFormMini from "components/forms/admin/AdminLessonTrainingRegistrationIDFormMini";

class TrainingCalendarWebEx extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      payload: [],
      payloadToRender: [],
      rndKey: 0,
      searchFieldCC: [
        {
          id: "searchAccountExt",
          field: "searchAccountExt",
          label: "AulaWebex",
          className: "form-control",
          onChange: (elm, value) => {
            this.onSearchForm("searchAccountExt", value);
          },
          payload: {
            options: ACCOUNT_WEBEX.list,
          },
        },
        {
          id: "searchDate",
          field: "searchDate",
          label: "Data lezione",
          className: "form-control",
          onChange: (elm, value) => {
            this.onSearchForm("searchDate", value);
          },
          payload: {
            options: [],
          },
        },
        {
          id: "searchHourStart",
          field: "searchHourStart",
          label: "Ora inizio",
          className: "form-control",
          onChange: (elm, value) => {
            this.onSearchForm("searchHourStart", value);
          },
          payload: {
            options: [
              { label: "Ora", value: "" },
              { label: "15:00", value: "15:00:00" },
              { label: "08:30", value: "08:30:00" },
            ],
          },
        } /*,
        {
          id: "searchFrom",
          field: "searchFrom",
          label: "dal",
          type: "date",
          className: "form-control",
          onChange: (elm, value) => {
            this.onSearchForm(value);
          },
          value: "",
        }*/,
      ],
    };
  }

  tableConfig = {
    columns: [
      {
        id: "id", // identifier of columns
        Header: "id",
        isVisible: false, // IMPORTANT: hidden columns
        accessor: "id", // accessor is the "key" in the data
      },
      {
        id: "teacher",
        Header: "docente",
        accessor: "teacher",
      },
      {
        id: "competitionClass",
        Header: "classe di concorso",
        accessor: "competitionClass",
      },
      /*{
        id: "ssd",
        Header: "ssd",
        accessor: "ssd",
      },
      {
        id: "sad",
        Header: "sad",
        accessor: "sad",
      },*/
      {
        id: "courseCode",
        Header: "corso",
        accessor: "courseCode",
      },
      {
        id: "creditRecognition",
        Header: "crediti riconosciuti",
        accessor: "creditRecognition",
      },
      {
        id: "date",
        Header: "data",
        accessor: (row) => {
          return row.date ? dateHelper.toITDate(row.date) : "";
        },
      },
      {
        id: "hourStart",
        Header: "inizio",
        accessor: (row) => {
          return row.hourStart
            ? row.hourStart.substring(0, row.hourStart.length - 3)
            : "";
        },
      },
    ],
  };

  //--- ---

  componentDidMount() {
    this.populateDateOptions();
    this.loadRemote();
  }

  populateDateOptions = () => {
    const options = [{ label: "Data", value: "" }];
    const startDate = new Date();

    for (let i = 0; i < 28; i++) {
      const currentDate = new Date(startDate);
      currentDate.setDate(startDate.getDate() + i);

      const label = currentDate.toLocaleDateString("it-IT"); // DD/MM/YYYY
      const value = currentDate.toLocaleDateString("en-CA"); // YYYY-MM-DD

      options.push({ label, value });
    }

    // Update the state with the new options
    const updatedSearchFieldCC = [...this.state.searchFieldCC];
    const dateFieldIndex = updatedSearchFieldCC.findIndex(
      (field) => field.id === "searchDate"
    );

    if (dateFieldIndex !== -1) {
      updatedSearchFieldCC[dateFieldIndex].payload.options = options;
    }

    this.setState({ searchFieldCC: updatedSearchFieldCC });
  };

  onSearchForm = () => {
    const searchAccountExt = document
      .getElementById("searchAccountExt")
      .value.trim();
    const searchDate = document.getElementById("searchDate").value.trim();
    const searchHourStart = document
      .getElementById("searchHourStart")
      .value.trim();
    //const searchTo = document.getElementById("searchTo").value.trim();

    let searchFieldCCUpdated = [...this.state.searchFieldCC];
    searchFieldCCUpdated[0].value = searchAccountExt;
    searchFieldCCUpdated[1].value = searchDate;
    searchFieldCCUpdated[2].value = searchHourStart;
    //searchFieldCCUpdated[3].value = searchTo;

    this.setState({
      ...this.state,
      searchFieldCC: searchFieldCCUpdated,
    });

    const results = this.state.payload.filter((item) => {
      let match = true;

      if (searchAccountExt) {
        match =
          match &&
          item.accountExt
            .toLowerCase()
            .includes(searchAccountExt.toLowerCase());
      }

      if (searchDate) {
        const itemDate = dateHelper.toUSDate(item.date);
        match = match && itemDate === searchDate;
      }

      if (searchHourStart) {
        match = match && item.hourStart.startsWith(searchHourStart);
      }

      return match;
    });

    this.setState({
      payloadToRender: results,
      rndKey: Math.floor(Math.random() * 1000 + 1),
    });
  }; //onSearchForm

  loadRemote() {
    const { archivied } = this.props.match.params || "";

    adminService
      .loadLessonTrainingCalendarWebexAccountGroup(archivied)
      .then(({ data }) => {
        const minDate = new Date("2025-09-01T00:00:00");
        const distinctHourStart = [
          ...new Set(
            data.payload.lessonLTrainingCalendarWebex
              .filter((item) => new Date(item.date) >= minDate) // ✅ condizione su date
              .map((item) => item.hourStart)
          ),
        ].sort((a, b) => {
          const [ah, am] = a.split(":").map(Number);
          const [bh, bm] = b.split(":").map(Number);
          return ah * 60 + am - (bh * 60 + bm);
        });

        const newState = {
          payload: data.payload.lessonLTrainingCalendarWebex || [],
          payloadToRender: data.payload.lessonLTrainingCalendarWebex || [],
          loading: false,
          searchFieldCC: [
            ...this.state.searchFieldCC.slice(0, 2),
            {
              ...this.state.searchFieldCC[2],
              payload: {
                options: [
                  { label: "Ora", value: "" },
                  ...distinctHourStart.map((hs) => ({
                    label: hs.substring(0, hs.length - 3),
                    value: hs,
                  })),
                ],
              },
            } /*,
            this.state.searchFieldCC[3]*/,
          ],
        };

        this.setState(newState);
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  } //loadremote

  loadRemoteFullDataSet(item, type) {
    const fileName = `Elenco_Corsisti_Training_${
      item.accountExt
    }_${item.classGroup.replaceAll(" ", "_")}_${item.teacher
      .replaceAll(" ", "_")
      .toLowerCase()}_${dateHelper.toITDate(item.date).replace("/", "_")}_${
      item.hourStart
    }_${type}`;

    adminService
      .loadLessonTrainingCalendarWebexAccountGroupExport(item)
      .then(({ data }) => {
        //---
        const array = data.payload.attendeesWebex;
        let str = "";
        if (type === "full") {
          str = "Nome;Indirizzo e-mail;Telefono\r\n";
        }
        if (type === "webex") {
          str = "Nome;Indirizzo e-mail\r\n";
        }

        for (let i = 0; i < array.length; i++) {
          let line = "";
          for (let index in array[i]) {
            // Prendo solo i primi 3 elementi
            if (
              index !== Object.keys(array[i])[0] &&
              index !== Object.keys(array[i])[1] &&
              index !== Object.keys(array[i])[2] &&
              type === "full"
            ) {
              continue;
            }
            if (
              index !== Object.keys(array[i])[0] &&
              index !== Object.keys(array[i])[1] &&
              type === "webex"
            ) {
              continue;
            }
            if (line !== "") line += ";";
            line += array[i][index];
          }

          str += line + "\r\n";
        }

        let downloadLink = document.createElement("a");
        downloadLink.href =
          "data:text/csv;charset=utf-8," + encodeURIComponent(str);
        downloadLink.download = fileName + ".csv";

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        //---
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.log(error);
        this.setState({ loading: false });
      });
  } //loadRemoteFullDataSet

  exportCurrentFull = () => {
    const { payloadToRender } = this.state;

    const searchAccountExt = document
      .getElementById("searchAccountExt")
      .value.trim();
    const searchDate = document.getElementById("searchDate").value.trim();
    const searchHourStart = document
      .getElementById("searchHourStart")
      .value.trim();

    // Base file name
    let fileName = "Elenco_Corsisti_Training_Completo";

    // Append dynamic parts if they are not empty
    if (searchAccountExt) {
      fileName += `_Account_${searchAccountExt.replace(/ /g, "_")}`;
    }
    if (searchDate) {
      fileName += `_Data_${searchDate.replace(/\//g, "_")}`;
    }
    if (searchHourStart) {
      fileName += `_Ora_${searchHourStart.replace(/:/g, "_")}`;
    }

    const header =
      "Nome;Indirizzo e-mail;Telefono;Corso;Aula Mnemosine;Docente;Aula Webex;Ora Inizio\r\n";

    // Array di Promise
    const promises = payloadToRender.map((item) =>
      adminService
        .loadLessonTrainingCalendarWebexAccountGroupExport(item)
        .then(({ data }) => {
          const attendees = data.payload.attendeesWebex;
          return attendees
            .map((att) => {
              const keys = Object.keys(att);
              const filteredKeys = keys.filter(
                (_, index) => index !== 3 && index !== 6
              );
              return (
                filteredKeys.map((k) => att[k]).join(";") +
                `;${item.teacher};${item.accountExt};${item.hourStart}`
              );
            })
            .join("\r\n");
        })
    );

    // resolve all promises
    Promise.all(promises)
      .then((results) => {
        // remove undefined values and join the results
        const body = results.filter((r) => r).join("\r\n");
        const csv = header + body;

        // download
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        console.error(error);
        this.setState({ loading: false });
      });
  };

  //--- ---

  render() {
    const { loading } = this.state;
    //if (loading) return (<MnemoLoading></MnemoLoading>);

    return (
      <>
        <div className="container mt-3 mb-4">
          <section className="m-0">
            <div className="form-row">
              <div className="col-md-12 text-right"></div>
            </div>
          </section>

          <hr />

          <section className="my-4">
            {loading ? (
              <MnemoLoading></MnemoLoading>
            ) : (
              <Container>
                <Title>Calendario Aule Webex Training</Title>

                <div className="form-row mb-4">
                  <div className="col-md-3">
                    <MSelect
                      {...this.state.searchFieldCC[0]}
                      className="mb-0"
                    />
                  </div>
                  <div className="col-md-3">
                    <MSelect
                      {...this.state.searchFieldCC[1]}
                      className="mb-0"
                    />
                  </div>
                  <div className="col-md-2">
                    <MSelect
                      {...this.state.searchFieldCC[2]}
                      className="mb-0"
                    />
                  </div>
                  <div className="col-md-4 text-right">
                    <Button
                      className="btn btn-primary bg-dark mx-1"
                      onClick={() => {
                        this.exportCurrentFull();
                      }}
                    >
                      Esporta giornata
                    </Button>
                  </div>
                </div>

                {(this.state.payloadToRender || []).map((item, index) => (
                  <Card
                    key={index}
                    tag="div"
                    className="card-bg card-big rounded shadow border-bottom-card mb-3"
                  >
                    <CardBody>
                      <div>
                        <section className="m-0 mb-2 p-0">
                          <div className="form-row">
                            <div className="col-md-8">
                              <h4 className="mb-0">
                                Account: {item.accountExt} - {item.classGroup}
                              </h4>
                              <h6 className="text-muted mb-0">
                                {/*item.teacher*/}
                                {dateHelper.toITDate(item.date)} dalle{" "}
                                {item.hourStart.substring(
                                  0,
                                  item.hourStart.length - 3
                                )}{" "}
                                alle{" "}
                                {item.hourEnd.substring(
                                  0,
                                  item.hourEnd.length - 3
                                )}
                              </h6>
                            </div>
                            <div className="col-md-4 text-right">
                              <Button
                                className="btn btn-primary bg-dark mx-1"
                                onClick={() => {
                                  this.loadRemoteFullDataSet(item, "full");
                                }}
                              >
                                Corsisti full
                              </Button>
                              <Button
                                className="btn btn-primary bg-dark mx-1"
                                onClick={() => {
                                  this.loadRemoteFullDataSet(item, "webex");
                                }}
                              >
                                Corsisti x Webex
                              </Button>
                            </div>
                          </div>
                        </section>

                        <Container>
                          <MTable
                            key={this.state.rndKey}
                            tableData={item.lessons || []}
                            tableConfig={this.tableConfig}
                          />
                        </Container>

                        <AdminLessonTrainingRegistrationIDFormMini
                          accountExt={item.accountExt}
                          date={dateHelper.toUSDate(item.date)}
                          hourStart={item.hourStart}
                          classGroup={item.classGroup}
                          idClass={item.idClass}
                        />
                      </div>
                    </CardBody>
                  </Card>
                ))}

                {(this.state.payloadToRender || []).length === 0 && (
                  <BoxDanger key="nrp-1" className="my-3">
                    Ricerca non valida.
                    <div className="small text-info">
                      Nessun dato disponibile.
                    </div>
                  </BoxDanger>
                )}
              </Container>
            )}

            {/*this.state.payload.length === 0 && (
              <BoxDanger key="nrp-1" className="my-3">
                Ricerca non valida.
                <div className="small text-info">Nessun dato disponibile.</div>
              </BoxDanger>
            )*/}
          </section>
        </div>
      </>
    );
  }
}

export default withRouter(TrainingCalendarWebEx);
